module.exports = __webpack_public_path__ + "img/dumpling_done.bb8f100f.jpg";